import { User } from './user-model';

export class SendSmsResponse {
  constructor(public success: boolean, public message: string) {}
}

export class UserResponse {
  constructor(
    public success: boolean,
    public message: string,
    public token: string,
    public refreshToken: string,
    public user: User
  ) {}
}

export class LoginGoogleParams {
  constructor(
    public idToken: string,
    public acquisitionSource: null,
    public market: string,
    public deviceId: string,
    public deviceType: string,
    public appVersion: string,
    public deviceVersion: string
  ) {}
}
export class LoginGoogleResponce {
  constructor(
    public success: boolean,
    public message: string,
    public token: string,
    public refreshToken: string,
    public user: User,
    public statusCode: number,
    public newUser: boolean
  ) {}
}
export class RefreshTokenResponse {
  constructor(
    public success: boolean,
    public token: string,
    public refreshToken: string
  ) {}
}

export class GetUserResponse {
  constructor(public data: User) {}
}

export class GetPromotionUser {
  constructor(public success: boolean, public hasPromotion: boolean) {}
}

export class RevokeResponse {
  constructor(public success: boolean) {}
}
